import React from "react";
import { ReactComponent as PennyLogo } from "../../assets/icons/penny_logo.svg";
import { ReactComponent as GoogleIcon } from "../../assets/icons/google.svg";
import { ReactComponent as AppleIcon } from "../../assets/icons/apple.svg";
import { Link, useNavigate } from "react-router-dom";
import {
  useSignInWithApple,
  useSignInWithGoogle,
} from "react-firebase-hooks/auth";
import { auth, auth_messages } from "@utils/firebase";

type EntryProps = {};

const Entry: React.FC<EntryProps> = () => {
  const navigate = useNavigate();

  const [signInWithGoogle, userGoogle, loadingGoogle, errorGoogle] =
    useSignInWithGoogle(auth);
  const [signInWithApple, userApple, loadingApple, errorApple] =
    useSignInWithApple(auth);

  const onSignInGoogle = () => {
    if (!userGoogle) {
      signInWithGoogle().catch((error) => {
        console.error("Google sign-in error:", error);
      });
    }
  };

  const onSignInApple = () => {
    if (!userApple) {
      signInWithApple().catch((error) => {
        console.error("Apple sign-in error:", error);
      });
    }
  };

  return (
    <section className="w-full grow flex items-center justify-center">
      <div className="max-w-full md:max-w-[400px] w-full py-10 mx-auto md:border md:border-pn_gray-200 bg-pn_paper-1 rounded-3xl">
        <div className="w-full py-4 px-6 flex items-center justify-center">
          <PennyLogo width={81} height={32} />
        </div>

        <div className="flex flex-col gap-y-4 py-4 px-6">
          <h2 className="text-center text-pn-large-title text-pn_gray-950">
            Welcome to Penny
          </h2>
          <span className="text-center text-pn-body-regular !font-normal text-pn_gray-600">
            Its nice to have you here! Please continue with your favourite
            authentication method
          </span>
        </div>

        <div className="py-4 px-6 flex flex-col gap-y-4">
          <button
            disabled={loadingGoogle || loadingApple}
            onClick={() => navigate("/signup")}
            className="btn-primary-lg"
          >
            Continue with Email
          </button>
          <button
            disabled={loadingGoogle || loadingApple}
            onClick={onSignInGoogle}
            className="btn-secondary-lg !bg-white flex items-center gap-x-4 justify-center"
          >
            <GoogleIcon />
            Continue with Google
          </button>
          <button
            disabled={loadingGoogle || loadingApple}
            onClick={onSignInApple}
            className="btn-secondary-lg !bg-pn_gray-950 !text-pn_gray-200 disabled:opacity-50 flex items-center gap-x-4 justify-center"
          >
            <AppleIcon />
            Continue with Apple
          </button>

          {((errorGoogle?.code && !['auth/cancelled-popup-request', 'auth/popup-closed-by-user'].includes(errorGoogle.code)) || (errorApple?.code && !['auth/cancelled-popup-request', 'auth/popup-closed-by-user'].includes(errorApple.code))) && (
            <span className="text-pn-callout-emphasis text-center text-pn_red-500">
              {auth_messages[errorGoogle?.code as keyof typeof auth_messages] ||
                auth_messages[errorApple?.code as keyof typeof auth_messages] ||
                "An error occurred. Please try again."}
            </span>
          )}
        </div>

        <div className="py-2 px-6 flex items-center gap-x-4">
          <div className="divider-dotted-gray w-full"></div>
          <span className="text-pn-caption-regular text-pn_gray-600">or</span>
          <div className="divider-dotted-gray w-full"></div>
        </div>

        <div className="py-4 px-6 flex items-center justify-center">
          <span className="text-pn-callout-regular text-center">
            Already have a Penny account?{" "}
            <Link className="text-pn-callout-link" to="/login">
              Sign in
            </Link>
          </span>
        </div>

        <div className="py-4 px-6 flex items-center justify-center">
          <span className="text-pn-callout-regular text-center">
            By proceeding, you agree to the{" "}
            <Link to="https://www.thisispenny.com/terms-of-business" className="text-pn-callout-link">
              Terms and Conditions
            </Link>{" "}
            and{" "}
            <Link to="https://www.thisispenny.com/privacy-policy" className="text-pn-callout-link">
              Privacy Policy
            </Link>
          </span>
        </div>
      </div>
    </section>
  );
};
export default Entry;
